import React from 'react';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import SearchIcon from '@material-ui/icons/Search';
import Tooltip from '@material-ui/core/Tooltip';

class Header extends React.Component {
  render() {
    return (
      <header id="header" className="header">
        <div className="container">
          <div className="col-l">
            <h1 id="app_title">
                  <SearchIcon style={{ marginRight: 4, verticalAlign: 'middle', fontSize: 28 }}/>
                  サイト内検索
            </h1>
          </div>
          <div className="col-r margin-top-xs">
            <Tooltip title="マニュアルを見る">
              <HelpOutlineIcon  style={{ fontSize: 28, cursor: 'pointer', }} onClick={() => { window.open( 'https://bindup.jp/support/' ) }} />
            </Tooltip>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;